import { getProducts } from '../../../../../store/model/authUser/selectors/getProducts';
import { IApplicationState } from '../../../../../types/types';
import { IPricingProducts } from '../types';

export const getPricingProducts = (
    state: IApplicationState
): IPricingProducts => {
    const pricingProducts: IPricingProducts = {};
    const products = getProducts(state);
    products.forEach(product => {
        if (!pricingProducts[product.frequency]) pricingProducts[product.frequency] = {};
        pricingProducts[product.frequency][product.pack.id] = product;
    });
    return pricingProducts;
};
